/**
 * Independence notice shown near the top of every school page.
 *
 * What: States that DeepThink is independent from the named school and MOE.
 * Why: Prevents an informational school page from implying an official affiliation.
 * When: Update only if the relationship or approved disclaimer wording changes.
 */
import { Paper, Typography } from '@mui/material';

import { colors, radii, shadows } from '@/components/landing/landingTokens';

interface SchoolIndependenceNoticeProps {
  schoolName: string;
}

function SchoolIndependenceNotice({
  schoolName,
}: SchoolIndependenceNoticeProps) {
  return (
    <Paper
      elevation={0}
      component="aside"
      aria-label="Independence and affiliation notice"
      sx={{
        p: { xs: 2, sm: 2.5 },
        maxWidth: 760,
        borderRadius: radii.md,
        backgroundColor: colors.backgroundAlt,
        border: `1px solid ${colors.border}`,
        borderLeft: `4px solid ${colors.accentCobalt}`,
        boxShadow: shadows.hairline,
      }}
    >
      <Typography
        variant="body1"
        component="p"
        sx={{
          fontSize: { xs: '0.875rem', sm: '0.9375rem' },
          color: colors.ink,
          lineHeight: 1.65,
        }}
      >
        DeepThink is an independent tuition provider and is not affiliated with,
        endorsed by, or operated by <strong>{schoolName}</strong> or the
        Ministry of Education. The school name is used for informational
        purposes to help parents identify tuition relevant to their child.
      </Typography>
    </Paper>
  );
}

export default SchoolIndependenceNotice;
